import script from "./AddVariantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddVariantModal.vue?vue&type=script&setup=true&lang=js"

import "./AddVariantModal.vue?vue&type=style&index=0&id=c02ebc1e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c02ebc1e"]])

export default __exports__